var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"network-error"}},[(_vm.networkErrorVissible)?_c('div',{staticClass:"network-error"},[_c('i',{staticClass:"el-icon-error"}),_vm._v(" "+_vm._s(_vm.$t('labels.network_error'))+"\n  ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }